import ServiceHighlights from "reusables/sections/ServiceHighlights";

const items = [
  {
    icon: "sentiment_very_satisfied",
    title: "Tailored to Your Needs",
    description: "A customised cleaning plan to address your specific requirements.",
  },
  {
    icon: "cleaning_services",
    title: "Comprehensive Deep Cleaning",
    description: "Ideal for spaces that need an intensive, top-to-bottom refresh.",
  },
  {
    icon: "today",
    title: "No Long-Term Commitment",
    description: "A single, hassle-free service without ongoing obligations.",
  },
  {
    icon: "groups",
    title: "Experienced Team",
    description: "Skilled professionals equipped to handle even the toughest cleaning challenges.",
  },
];

function OneOff_Section1() {
  return (
    <ServiceHighlights
      title="Why Choose Our One-Off Cleaning?"
      description="When your space needs a deep and thorough clean, our One-Off Cleaning Services are here to help. Ideal for tackling spring cleaning, post-event messes, or simply giving your home or office a refreshing reset, our professional team delivers exceptional results."
      items={items}
    />
  );
}

export default OneOff_Section1;
